/* global photoOrg */
const intersectionObserverHandler = {
    domCache: {},
    initialize: () =>{
        if(photoOrg.rcExtSourceObserver){
           return;
        }
        photoOrg.rcExtSourceObserver = new IntersectionObserver(function(entries,observer) {
            entries.forEach(function(entry){
                //for some browsers if isIntersecting is undefined ,intersectionRatio is considered to know div is in view port
                if(entry.isIntersecting === true || ((typeof entry.isIntersecting === "undefined") && entry.intersectionRatio > 0)){
                    const albumId = entry.target.getAttribute("aid");
                   if(!entry.target.querySelector(".album-item") && intersectionObserverHandler.domCache[albumId]){
                    entry.target.style.border= "";
                    intersectionObserverHandler.attach(entry.target, intersectionObserverHandler.domCache[albumId])
                    intersectionObserverHandler.domCache[albumId]=""
                   }
                   //console.log("visible")
                }else{
                    //console.log("not-visible")
                    entry.target.style.border= "1px solid lightgray";
                    intersectionObserverHandler.domCache[entry.target.getAttribute("aid")] = intersectionObserverHandler.detach(entry.target)
                }
            });
        },{
            root:null,
            threshold: 0.05
        })
    },
    observe: () => {
        var elements = document.querySelectorAll(".observerable-div-rc");
        elements.forEach(function(element){
            element.classList.remove("observerable-div-rc")
            element.classList.add("observerable-listened-rc");
            photoOrg.rcExtSourceObserver.observe(element);
        })
    },
    unobserve: () => {
        if(photoOrg.rcExtSourceObserver){
            intersectionObserverHandler.domCache = {}
            photoOrg.rcExtSourceObserver.disconnect(); 
        }
    },
    detach: (node) => {
        return node.removeChild(node.querySelector(".item-sec-div"));
    },
    attach: (node,content) => {
        return node.appendChild(content);
    }
}

export default intersectionObserverHandler;